export const getInvoiceHref = (itemId, skuId) => {
    const qp = skuId ? `?skuId=${skuId}` : '';
    return `/my/orders/invoice/id-${itemId}${qp}`;
};
